import { AsyncPipe, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { PromoCmsComponents } from '@core/const';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { SdBannerContentModule } from '../banner-content';
import { SdSubstrateResponsiveBannerComponent } from './substrate-responsive-banner.component';

@NgModule({
  declarations: [SdSubstrateResponsiveBannerComponent],
  imports: [
    NgIf,
    AsyncPipe,
    SdBannerContentModule,
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        [PromoCmsComponents.RosaCMSSubstrateResponsiveBannerComponent]: {
          component: SdSubstrateResponsiveBannerComponent,
        },
      },
    }),
  ],
})
export class SdSubstrateResponsiveBannerModule {}
